export { default as DistratosDigitalizados } from "./DistratosDigitalizados"
export { default as TableDistratosDigitalizados } from "./TableDistratosDigitalizados"
export { default as DistratosDigitalizadosTrash } from "./DistratosDigitalizadosTrash"
export { default as TableDistratosDigitalizadosTrash } from "./TableDistratosDigitalizadosTrash"
export { default as DistratosDigitalizadosCreateForm } from "./DistratosDigitalizadosCreateForm"



// WEBPACK FOOTER //
// ./src/views/distratos/digitalizados/index.js